import { render, staticRenderFns } from "./CompetitionsViewQuestionsView.vue?vue&type=template&id=0def6cc6&"
import script from "./CompetitionsViewQuestionsView.vue?vue&type=script&lang=js&"
export * from "./CompetitionsViewQuestionsView.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsViewQuestionsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports